import SquareColor from "./SquareColor";

export default SquareColor;
